// GraphQL queries for store credit management

// Query to get customer store credit balance and history
export const CUSTOMER_STORE_CREDIT_QUERY = `
  query GetCustomerStoreCredit {
    customer {
      store_credit {
        enabled
        current_balance {
          value
          currency
        }
        balance_history {
          items {
            balance_change {
              value
              currency
            }
            date_time_changed
            action
            actual_balance {
              value
              currency
            }
          }
          page_info {
            current_page
            page_size
            total_pages
          }
        }
      }
    }
  }
`;

// Query to check gift card balance
export const GIFT_CARD_BALANCE_QUERY = `
  query GetGiftCardAccount($input: GiftCardAccountInput!) {
    giftCardAccount(input: $input) {
      code
      balance {
        currency
        value
      }
      expiration_date
    }
  }
`;

// Mutation to redeem gift card as store credit
export const REDEEM_GIFT_CARD_MUTATION = `
  mutation RedeemGiftCard($input: GiftCardAccountInput!) {
    redeemGiftCardBalanceAsStoreCredit(input: $input) {
      balance {
        value
        currency
      }
      code
      expiration_date
    }
  }
`;

// Data transformation helper to convert GraphQL store credit response to REST format
export const transformStoreCreditDataToRest = (storeCredit) => {
  if (!storeCredit) return { balance: 0, history: [] };
  
  return {
    balance: storeCredit.current_balance?.value || 0,
    currency: storeCredit.current_balance?.currency || 'USD',
    enabled: storeCredit.enabled || false,
    history: (storeCredit.balance_history?.items || []).map(item => ({
      action: item.action,
      balanceDelta: item.balance_change?.value || 0,
      balanceAmount: item.actual_balance?.value || 0,
      updatedAt: item.date_time_changed
    }))
  };
};

// Data transformation helper to convert GraphQL gift card response to REST format
export const transformGiftCardDataToRest = (giftCardAccount) => {
  if (!giftCardAccount) return { balance: 0, code: '', expiration_date: null };
  
  return {
    balance: giftCardAccount.balance?.value || 0,
    currency: giftCardAccount.balance?.currency || 'USD',
    code: giftCardAccount.code || '',
    expiration_date: giftCardAccount.expiration_date
  };
};
